import { useTranslation } from 'react-i18next';

import { Section } from 'components/Display/Section/Section';

import { ReadOnlyIndicator } from './ReadOnlyIndicator';

type MailboxSectionProps = {
  email: string;
};

export const MailboxSection = ({ email }: MailboxSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section.Horizontal
      title={t('settings:documentUnderstandingAgent.global.mailbox.title')}
      description={t('settings:documentUnderstandingAgent.global.mailbox.description')}
      action={<ReadOnlyIndicator />}
    >
      <span className="text-sm text-gray-700">{email}</span>
    </Section.Horizontal>
  );
};
